import React, { useEffect, useState } from 'react'
import { getIcons } from '../Constant/Constant'
import { use } from 'react';
import CallLogService from '../Services/CallLogService';
import { useNavigate } from 'react-router-dom';

const CallLog = ({callLogHistory}) => {
    const icons = getIcons();
    const [searchQuery, setSearchQuery] = useState('');

  // const filteredCallLogHistory = callLogHistory.filter(call =>
  //   call.leadName.toLowerCase().includes(searchQuery.toLowerCase())
  // );
    const navigate = useNavigate();

    const userData = JSON.parse(localStorage.getItem("userData"));
    const userRole = userData?.user?.role;
    const handleLeadInfo = (lead) => {
console.log("jhg")
      let path = "";
      if (userRole === "Admin" ) {
        path = `/admin/lead-info/${lead}`;
      } else if(userRole === "CMO"){
        path = `/cmo/lead-info/${lead}`;

      }else if (userRole === "MD") {
        path = `/md/lead-info/${lead}`;
      } else if (userRole === "BOD") {
        path = `/bod/lead-info/${lead}`;
      }
      navigate(path)
    };
  const filteredCallLogHistory = Array.isArray(callLogHistory) ? callLogHistory.filter(call =>
    call.leadName.toLowerCase().includes(searchQuery.toLowerCase())
) : [];

    const statusImage = {

        "Registered Client": icons.customerIcon,
        Fresh: icons.freshIcon,
        Dealing: icons.dealingIcon,
        "Deal Lost": icons.dealLostIcon,
        "Follow-up": icons.interestedIcon,
        "Retry Suitable": icons.RetrySuitable,
        "Not Interested": icons.notInterestedIcon,
"Unanswered": icons.unansweredIcon,

    }
    const leadCharacter={
        "Not Applicable":icons.NAEmoji,
        Excited:icons.excitedEmoji,
        Neutral:icons.neutralEmoji,
        Confused:icons.confusedEmoji,
        Thinking:icons.ThinkingEmoji
    }


    const [selectedTab, setSelectedTab] = useState("all"); // Default to "All Calls"

  const filteredCalls = filteredCallLogHistory?.filter((call) => {
    if (selectedTab === "missed") return call?.callType === 2;
    if (selectedTab === "incoming") return call?.callType === 0;
    if (selectedTab === "outgoing") return call?.callType === 1;
    return true; // Show all calls by default
  });
  return (
    <div>
      <div className=' border border-gray-400 rounded-lg flex items-center gap-2 h-10 px-4'>
<img src={icons.searchIcon} alt="" />
<input onChange={(e)=>setSearchQuery(e.target.value)} type="text" className='w-full h-full focus:outline-none ' placeholder='Type Customer/Lead Name ' />
      </div>

      {/* <div className=' border flex justify-between rounded-xl shadow-md mt-4 p-3'>
        <div className='flex flex-col gap-2'>
            <div>
<h1 className='text-xl font-semibold'>Abi</h1>
            </div>
            <div className='flex items-center gap-2'>
                <img src={icons.incomingCall} alt="" />
                <span>Today 10:30 AM</span>
                <img src={icons.timerIcon} alt="" />
                <span>0h : 15 m : 25 s</span>
            </div>
        </div>
        <div className='flex items-center gap-4'>
            <div className='flex flex-col items-center gap-2'>
                <img src={statusImage['Registered Client']} alt="" />
                <h4>Registered Client</h4>
            </div>
            <div className='flex flex-col items-center '>
                <img src={leadCharacter.Excited} alt="" />
                <h4>Excited</h4>
            </div>
        </div>

      </div> */}


<div className="flex justify-around border-b pb-2">
        {["all", "incoming", "outgoing", "missed"].map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 ${
              selectedTab === tab ? "text-customGreen font-bold border-b-2 border-customGreen" : "text-gray-500"
            }`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab === "all"
              ? "All Calls"
              : tab === "incoming"
              ? "Incoming Calls"
              : tab === "outgoing"
              ? "Outgoing Calls"
              : "Missed Calls"}
          </button>
        ))}
      </div>

<div className='overflow-y-auto customScrollbar p-2 h-80'>



{filteredCalls?.length === 0 ? (
  <div className='text-center flex flex-col items-center  mt-10'>
    <img src={icons.noCallLog} className='w-40' alt="" />
    <p className='text-customGreen'>No call logs available.</p>
  </div>
) : (
  filteredCalls?.map((call, index) => (
    <div key={index}
    onClick={()=>handleLeadInfo(call?.leadDocId)}

    className='border flex justify-between rounded-xl shadow-md mt-4 p-3 '>
      <div className='flex flex-col gap-2'
>
        <div>
        <h1 className='text-xl font-semibold'>{call?.leadName.replace(/\b\w/g, (char) => char.toUpperCase())}</h1>
        </div>
        <div className='grid grid-cols-2 gap-2'>
          <div className='flex items-center gap-2'>
            <img src={call?.callType === 0 ? icons.incomingCall : call.callType === 1 ? icons.outGoingCall : call?.callType === 2 ? icons.missedCall: ""} alt="" />
            <span>{call?.convertedCallMadeTimeStamp}</span>
          </div>
          <div className='flex items-center gap-2'>
            <img src={icons.timerIcon} alt="" />
            <span>{`${Math.floor(call?.callDurationInSeconds / 3600)}h : ${Math.floor((call?.callDurationInSeconds % 3600) / 60)}m : ${call?.callDurationInSeconds % 60}s`}</span>
          </div>
        </div>
      </div>
      <div className='flex items-center gap-4'>
        <div className='flex flex-col items-center gap-2'>
          <img src={statusImage[call?.status]} alt="" />
          <h4>{call?.status}</h4>
        </div>
        <div className='flex flex-col items-center '>
          <img src={leadCharacter.Excited} alt="" />
          <h4>Excited</h4>
        </div>
      </div>
    </div>
  ))
)}
</div>

{/* {callLogHistory.map((call, index) => (
        <div key={index} className='border flex justify-between rounded-xl shadow-md mt-4 p-3 '>
          <div className='flex flex-col gap-2'>
            <div>
              <h1 className='text-xl font-semibold'>{call.leadName}</h1>
            </div>
            <div className='grid grid-cols-2 gap-2'>
                <div className='flex items-center gap-2'>

              <img src={call.callType === 0 ? icons.incomingCall : call.callType === 1 ? icons.missedCall : call.callType === 2 ? icons.missedCall: ""} alt="" />
              <span>{call.convertedCallMadeTimeStamp}</span>
              </div>
                <div className='flex items-center gap-2'>
              <img src={icons.timerIcon} alt="" />
              <span>{`${Math.floor(call.callDurationInSeconds / 3600)}h : ${Math.floor((call.callDurationInSeconds % 3600) / 60)}m : ${call.callDurationInSeconds % 60}s`}</span>
          </div>
            </div>
          </div>
          <div className='flex items-center gap-4'>
            <div className='flex flex-col items-center gap-2'>
              <img src={statusImage[call.status]} alt="" />
              <h4>{call.status}</h4>
            </div>
            <div className='flex flex-col items-center '>
              <img src={leadCharacter[call.leadCharacter]} alt="" />
              <h4>{call.leadCharacter}</h4>
            </div>
          </div>
        </div>
      ))} */}
    </div>
  )
}

export default CallLog

